import React from 'react';
import {DefaultButton, IButtonStyles, TooltipHost} from '@fluentui/react';

/**
 * Compact rounded "suggestion" chip used under search boxes (suggested opportunities, suggested
 * companies). A long label must be the only part of the pill that shrinks: the text container needs
 * minWidth 0 so the ellipsis engages instead of the flex row overflowing the root, and both icons are
 * pinned so they are not squeezed or pushed outside the pill.
 */
export const PILL_STYLES: IButtonStyles = {
    root: {borderRadius: 16, height: 28, minWidth: 0, padding: '0 10px', maxWidth: 260, overflow: 'hidden'},
    flexContainer: {maxWidth: '100%'},
    textContainer: {minWidth: 0},
    // Fluent's 100% line height at 12px clips descenders once overflow is hidden; 16px leaves room for them.
    label: {fontWeight: 400, fontSize: 12, lineHeight: '16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'},
    icon: {fontSize: 12, flexShrink: 0},
    menuIcon: {flexShrink: 0}
};

interface ISuggestionPillProps {
    text: string;
    iconName: string;
    /** Tooltip body; defaults to the text so a truncated label is still readable. */
    tooltip?: string | JSX.Element;
    ariaLabel?: string;
    onClick: () => void;
    disabled?: boolean;
}

const SuggestionPill: React.FC<ISuggestionPillProps> = (props) => (
    <TooltipHost content={props.tooltip ?? props.text}>
        <DefaultButton
            text={props.text}
            iconProps={{iconName: props.iconName}}
            styles={PILL_STYLES}
            ariaLabel={props.ariaLabel ?? props.text}
            onClick={props.onClick}
            disabled={props.disabled}
        />
    </TooltipHost>
);

export default SuggestionPill;
